export default "__VITE_ASSET__DJGT$EkZ__"